import styled from 'styled-components';

const CheckboxLabel = styled.span`
  margin-left: 6px;
  color: ${({ active }) => (active ? 'black' : '#999')};
`;

export default CheckboxLabel;
